module.exports = __webpack_public_path__ + "img/Logo_Lexus.e1caf72a.svg";